export function hasActiveFacets(
  selectedFacets: Record<string, string[]>,
): boolean {
  return Object.values(selectedFacets).some((values) => values.length > 0);
}
